import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={10 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 10 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M8.61445 7.53698C8.56929 7.83106 8.49373 8.44262 8.22527 9.00443C7.96314 9.55249 7.70988 9.73381 7.61871 10.3231C7.12484 13.5053 7.22783 14.0145 6.18648 17.8231C5.4938 20.357 4.78057 25.2343 4.29303 25.3231C3.75189 25.4215 3.34706 20.6355 3.29303 17.8231C2.79303 13.9841 1.66936 12.8596 1.47899 10.4185C1.3895 9.26818 1.38972 9.02188 1.29306 8.71777C1.21033 8.4571 0.818379 8.15857 0.784188 7.81881C0.668953 6.68035 0.69471 4.3663 0.793061 2.77483C0.850468 1.84319 0.987647 1.46185 1.73604 1.40096C3.3485 1.26988 6.74072 1.30924 8.18686 1.48153C8.70817 1.54354 8.75375 1.87995 8.76811 2.49523C8.8023 3.99424 8.83606 6.09664 8.61445 7.53698Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
